import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { AlertCircle, X } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useEffect, useState } from 'react';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUserId, stopImpersonation } = useAuth();
  const [impersonatedEmail, setImpersonatedEmail] = useState('');

  useEffect(() => {
    if (isImpersonating && impersonatedUserId) {
      supabase
        .from('profiles')
        .select('email')
        .eq('id', impersonatedUserId)
        .single()
        .then(({ data }) => {
          if (data) setImpersonatedEmail(data.email);
        });
    }
  }, [isImpersonating, impersonatedUserId]);

  if (!isImpersonating) return null;

  return (
    <div className="bg-orange-500 text-white px-4 py-3 flex items-center justify-between shadow-lg">
      <div className="flex items-center gap-3">
        <AlertCircle className="h-5 w-5" />
        <span className="font-semibold">
          Impersonating: {impersonatedEmail || 'User'}
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={stopImpersonation}
        className="text-white hover:bg-white/10 transition-colors"
      >
        <X className="h-4 w-4 mr-2" />
        Stop Impersonation
      </Button>
    </div>
  );
}
